export default [
  'ingredientSelection',
  'brandAnalytics',
  'consumerProducts',
  'formulationDesign',
  'marketOverview',
  'boss',
  // 'topRanking',
  // 'bevol',
  'productInsights',
  'brandInsights',
  'claimInsights',
  'home-page',
  'concept-list',
  'trend-list',
  'basf-product-list',
  'topRankingBevol',
  'formulation-list',
  'webinarList',
  'event-list',
  'event',
  'ingredientClient'
  // 'formulationNewDesign'
].join()



// WEBPACK FOOTER //
// ./src/router/include.js